import { CultureInfo } from '../culture-info.model';
import { CultureInfoSyr } from './syr';

/**
 * @ignore
 */
export const CultureInfoSyrIQ: CultureInfo = {
  name: 'syr-IQ',
  displayName: 'ܣܘܪܝܝܐ (IQ)',
  iso3LanguageCode: 'syr',
  iso2LanguageCode: 'syr',
  ietfLanguageTag: 'syr-IQ',
  parent: CultureInfoSyr
};
